export default __webpack_public_path__ + "static/media/ngamen_dapat_uang.1ab337fd.svg";